var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestEval(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "107px",
    height: "135px",
    viewBox: "0 0 107 135",
    enableBackground: "new 0 0 107 135",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 107,
    height: 135,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAACHCAQAAAC7MG9+AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZ cwAALiMAAC4jAXilP3YAAAAHdElNRQfmCxUJEBRDFzkgAAAB9klEQVR42u2d0VHCQBRFL04KoAPS genAUIkpQSsQK4ASYiXGDrCDlEAH+qGOHxrj3Zns4y738AfZ4Z3JHcjuPsLqDUl0qNMGUozo0wau ErUG3GTQekGbNvAqQ3EBVKjRUSMGDJlrZCsE+go1HshB+bXoCgsNobWUsJYS1lKiUK3qxzPbmRFj 9hqPszU12M9pDdnLnuPE13QxIfxgmBzRp86Bkmlw+OPVltGank1NCy/Fmp/bXVgI5+iznLUxv9ZZ 4xB+0qUumySzzqG1wSazVgKFhtBaSlhLCWspYS0lrKUEd014j2NYpR1ul9I6Bq5LtczBDiGAA05h ldbLaV2HSZEUGkJrKWEtJQrV4j7gX0O/t4iFPE7rLvDiace0CDmEiFio/oZ6Z06LmBrEUmgIraWE tZSwlhKc1harsMfjcloyFKrFXTw9R5f7Xwo9W9ZSwlpKWEsJ7nvrKaAL/ouW6djltPK0sv7OjtFy COHdyGgKDaG1lLCWEoVqeTcS3o2MhjtbTWCl9XJae+roQAoNobWUsJYS1lLC7f1we3803o1UwlpK WEsJaynh3Uh4NzIat/fD7f3RWEsJaylhLSWspYS1lLCWEtZSwlpKWEuJqbWMufvlnzn8/eAluJgQ DtElJbCe18rxL2iLU2gIC9WqMHK/lpdgfAfrAkC52sJJKAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAy Mi0xMS0yMVQwODoxNjoyMCswMTowMIYXCcgAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjItMTEtMjFU MDg6MTY6MjArMDE6MDD3SrF0AAAAAElFTkSuQmCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestEval);
export default __webpack_public_path__ + "static/media/TestEval.73efe7724da6518508874b7646b54131.svg";
export { ForwardRef as ReactComponent };